import { render, staticRenderFns } from "./examendelete.vue?vue&type=template&id=cd00b608&"
import script from "./examendelete.vue?vue&type=script&lang=js&"
export * from "./examendelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports